import styled from "styled-components"
import { devices } from "../../../../themes/theme"

const Description = styled.span`
  font-size: clamp(0.725rem, 0.645rem + 0.4vw, 1.125rem);
  margin-block-start: clamp(1rem, 0.8rem + 1vw, 2rem);
  display: block;
`
const StyledH1 = styled.h1`
  font-size: clamp(1.3rem, 0.96rem + 1.7vw, 3rem);
  line-height: 120%;
  letter-spacing: 0.04em;
  font-weight: 700;
  text-align: center;
  margin: 0;
`
const StyledHgroup = styled.hgroup`
  @media ${devices.tablet} {
    width: 80%;
  }
  @media ${devices.laptop} {
    width: 65%;
  }
`
const Title = () => {
  return (
    <StyledHgroup>
      <StyledH1>シミュレーション結果</StyledH1>
      <Description>
        このシミュレーションは一例です。この結果にはジョーシスの利用料金分は含まれておりません。別途お見積りください。
      </Description>
    </StyledHgroup>
  )
}

export { Title }
